import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-printinner',
    templateUrl: 'printinner.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PrintinnerComponent implements OnInit {
    private appURL: string = environment.apiUrl;
    constructor(
        private router: Router,
        private _flashMessagesService: FlashMessagesService

    ) { }
    ngOnInit(): void {

    }

    public mprint() {
        window.print();
    }

}



// WEBPACK FOOTER //
// ./src/app/printinner.component.ts